import { BaseModel } from './base-model.model';
import { OperacaoGarantida, DetalheOperacaoGarantida, LiberacaoOperacaoGarantida } from './operacao-garantida.model';
import {Generos, GenerosEnum} from './generos-enum';


export class OperacaoCreditoLivre extends OperacaoGarantida {

    /* campos enviados pelo Agente Financeiro */
    public idOperacaoAgente: string;
    public modalidade: string;
	public razaoSocialClienteFinal: string;
	public cnaePortariaGrandeEmpresa: string;
    public indexadorTaxaJuros: string;
    public percentualIndexador: number;
    public taxaEfetivaAnual: number;
    public naturezaClienteFinal: string;
    public codigoIbgeMunicipioInvestimento: string;
    public dataPrimeiraLiberacao: Date;
    public valorPrimeiraLiberacao: number;
    public outrasGarantias: OutrasGarantias[];
    public ecgDeveSerSomadoAoValorOperacao: string;

    public enderecoSedeClienteFinal: EnderecoSede;

    /* os detalhes sao carregados apenas na consulta dos detalhes da operacao */
    public detalheCreditoLivre: DetalheOperacaoCreditoLivre;

    public amortizacoes: Amortizacao[];
    public amortizacoesAntecipadas: Amortizacao[] = [];

    public historico?: boolean;

  public dataNascSocioBeneficiario: Date;
  public generoSocioBeneficiario: string;
  public identificadorTipoPagamentoEcgTerceiro: number;
  public codigoValidadorPagamentoTerceiros: string;

    public getUltimaAmortizacaoAntecipada(): Amortizacao {
        return this.amortizacoesAntecipadas.length > 0 ? this.amortizacoesAntecipadas
            .map(a => this.ajustaCampoDate(a))
            .reduce((a1, a2) => a1.id > a2.id ? a1 : a2) : null;
	}

	ordenaAmortizacoesCronologicamente() {
		this.amortizacoes = this.getAmortizacoesOrdinarias()
			.sort((a1, a2) => {
			  return a1?.data?.getTime() - a2?.data?.getTime();
			});
	}

    public getAmortizacoesOrdinarias(): Amortizacao[] {
        return this.amortizacoes
            .map(a => {
                a?.data ? a.data = this.ajustaCampoDate(a.data): null;
                return a;
            });
    }

    public getTodasAmortizacoes(): Amortizacao[] {
        return OperacaoCreditoLivre._getTodasAmortizacoes(this.amortizacoesAntecipadas, this.amortizacoes);
    }

    public static _getTodasAmortizacoes(amortizacoesAntecipadas, amortizacoes): Amortizacao[] {
        return amortizacoesAntecipadas
            .map(a => {
                a.antecipada = true;
                return a;
            })
            .concat(amortizacoes)
            .map(a => {
                a?.data ? a.data = this._ajustaCampoDate(a.data): null;
                return a;
            }).sort((a1, a2) => {
                return a1?.data?.getTime() - a2?.data?.getTime();
            });
    }

    private ajustaCampoDate(data:any) {
		return OperacaoCreditoLivre._ajustaCampoDate(data);
    }

    private static _ajustaCampoDate(data:any) {
        if (typeof data === 'string') {
            if (data.length == 10) {
                data += ' 00:00:00';
            }
            return new Date(data);
        }
        return data;
    }

    public getNumeroAmortizacao(amortizacao: Amortizacao) {
        return this.getAmortizacoesOrdinarias()
            .filter(a => a.data <= amortizacao.data)
            .length;
    }

    public totalizaLiberacoes () {
        let total: number = this.detalhe.liberacoes
                .map(item => Number(item.valor))
                .reduce((acumulado, v) => acumulado + v, 0);
        if (this.ecgDeveSerSomadoAoValorOperacao === 'S') {
              total += this.detalhe.liberacoes
                  .map(item => Number(item.valorEcg))
                  .reduce((acumuladoEcg, v) =>  acumuladoEcg + v, 0);
        }
		if (this.detalhe.aditivos) {
			total += this.detalhe.aditivos
				.filter(item => item.ecgDeveSerSomadoAoValorOperacao === 'S' && item.detalhe.estado.id == 5) // estado 5 = EFETIVADO
				.map(item => Number(item.valorEcgComplementar))
				.reduce((acumuladoEcgComplementar, v) =>  acumuladoEcgComplementar + v, 0);
		}
        return total;
    }

    public atribuiSaldoPosAmortizacao() {
        let saldoAposAmortizacao = this.totalizaLiberacoes();

        const amortizacoes = this.getTodasAmortizacoes();

        if (amortizacoes[0]) {
            for (let i = 0; i < amortizacoes.length; i++) {
                saldoAposAmortizacao -= amortizacoes[i].valor;
                amortizacoes[i].saldoPosAmortizacao = saldoAposAmortizacao; //campo transiente
            }
        }
	  }

	public static fromDto(dto): OperacaoCreditoLivre {
		let operacao = new OperacaoCreditoLivre();
        for (let key in dto) {
			operacao[key] = dto[key];
		}
		return operacao;
	}
}

export class Amortizacao {
    public id: number;
    public data: Date;
    public valor: number;
    public saldoPosAmortizacao: number; // transiente para uso na tela de operações/aba amortizações
    public antecipada: boolean; //transiente
	public indice: number; //transiente
}

export class OutrasGarantias {
    public tipoGarantia: string;
}

export class PagamentoPorTerceiro {
    public ideTipoPagamento: number;
	public nome: string;
}

export class EnderecoSede {
    public nomeLogradouro: string;
    public tipoLogradouro: string;
    public numeroLogradouro: string; // admite S/N
    public complemento: string;
    public nomeBairro: string;
    public codigoIbgeMunicipio: string;
    public cep: string;

    // usados apenas na tela de detalhes
    public nomeTipoLogradouro: string;
    public nomeMunicipio: string;
}

export class DetalheOperacaoCreditoLivre {

    public historicos: HistoricoOperacaoCreditoLivre[];

    public nomeIndexadorTaxaJuros: string;
    public nomeMunicipioInvestimento: string;
	public nomeNaturezaClienteFinal: string;
	public nomeCnaePortariaGrandeEmpresa: string;
}


// TODO: a ser revisto no futuro...

export class HistoricoOperacaoCreditoLivre extends BaseModel {

	public idOperacaoAgente: string;
	public modalidade: string;
	public nomeEstado: string;
	public motivoEstado: string;
	public dataContratacao: Date;
	public cnpjAgenteFinanceiro: string;
	public cnpjClienteFinal: string;
	public outrasGarantias: OutrasGarantias[];
	public razaoSocialClienteFinal: string;
	public cnaePortariaGrandeEmpresa: string;
	public riscoOperacao: string;
	public valorPerdaEsperada: number;
	public percentualGarantido: number;
	public valorOperacao: number;
	public nomeIndexadorTaxaJuros: string;
	public percentualIndexador: number;
	public taxaEfetivaAnual: number;
	public nomeNaturezaClienteFinal: string;
	public cnaeClienteFinal: string;
	public nomeMunicipioInvestimento: string;
	public enderecoSedeClienteFinal: EnderecoSede;
	public dataAlteracao: Date;
	public nomeUsuarioResponsavel: string;
	public nomeCnaeClienteFinal: string;
	public nomeCnaePortariaGrandeEmpresa: string;
	public valorCredito: number;
	public valorGarantido: number;
	public fatorK: number;
	public valorEcg: number;
	public ecgDeveSerSomadoAoValorOperacao: string;
	public liberacoes: LiberacaoOperacaoGarantida[];
	public amortizacoes: Amortizacao[];
  public telefoneBeneficiario: string;
  public numeroAgenciaBeneficiario: number;
  public nomeSocioBeneficiario: string;
  public emailBeneficiario: string;
  public cpfSocioBeneficiario: string;
  public dataNascSocioBeneficiario: Date;
  public generoSocioBeneficiario: string;
}


export class NovasLiberacoesParaOperacao extends BaseModel {
	public idOperacaoAgente: string;
	public liberacoes: LiberacaoOperacaoGarantida[];
	public amortizacoes: Amortizacao[];
}

export class NovaAmortizacaoAntecipada extends BaseModel {
	public idOperacaoAgente: string;
    public fluxoParcelasAposAmortizacao: Amortizacao[];
    public valorTotalAmortizacaoAntecipada: number;
    public dataPagamentoAmortizacao: Date;
}

// JSON de exemplo para importacao de lote de operacoes garantidas

export const loteOperacoesExemplo =

`
{
	"operacoes": [
		{
			"idOperacaoAgente": "creditolivre-1",
			"modalidade": "1",
			"tipoReceitaBruta": "E",
			"receitaBrutaClienteFinal": 360000.01,
			"dataReferenciaReceitaBruta": "2019-12-31",
			"cnpjAgenteFinanceiro": "79486147000193",
			"razaoSocialClienteFinal": "North Central Positronics",
			"cnpjClienteFinal": "46051185000164",
			"riscoOperacao": "AA",
			"dataContratacao": "2020-06-10",
			"valorOperacao": 50000.00,
			"ecgDeveSerSomadoAoValorOperacao": "N",
			"percentualGarantido" : 80.00,
			"indexadorTaxaJuros": 2,
			"percentualIndexador": 100.00,
			"taxaEfetivaAnual": 8.00,
			"outrasGarantias": [
				{"tipoGarantia": "1"},
				{"tipoGarantia": "5"}
			],
			"naturezaClienteFinal": 1,
			"cnaeClienteFinal": "B0500300",
			"cnaeEnquadramento": "B0500300",
			"codigoIbgeMunicipioInvestimento": "3304557",
			"enderecoSedeClienteFinal": {
				"nomeLogradouro": "Rua do cliente",
				"tipoLogradouro": "1",
				"numeroLogradouro": "S/N",
				"complemento": "apt. 203",
				"nomeBairro": "Flamengo",
				"codigoIbgeMunicipio": "3304557",
				"cep": "22230060"
			},
      		"dataPrimeiraLiberacao": "2020-06-15",
      		"valorPrimeiraLiberacao": 50000,
			"amortizacoes": [
				{
					"data": "2021-02-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-03-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-04-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-05-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-06-15",
					"valor": "10000.00"
				}
			]
		},
		{
			"idOperacaoAgente": "creditolivre-2",
			"modalidade": "2",
			"tipoReceitaBruta": "E",
			"receitaBrutaClienteFinal": 300000000.00,
			"dataReferenciaReceitaBruta": "2019-12-31",
			"cnpjAgenteFinanceiro": "79486147000193",
			"razaoSocialClienteFinal": "Tinturaria ABCD",
			"cnpjClienteFinal": "89495936000144",
			"riscoOperacao": "AA",
			"dataContratacao": "2020-06-10",
			"valorOperacao": 80000.00,
			"ecgDeveSerSomadoAoValorOperacao": "S",
			"percentualGarantido" : 80.00,
			"indexadorTaxaJuros": 3,
			"percentualIndexador": 90.00,
			"taxaEfetivaAnual": 8.00,
			"outrasGarantias": [
				{"tipoGarantia": "1"}
			],
			"naturezaClienteFinal": 1,
			"cnaeClienteFinal": "B0500300",
			"cnaeEnquadramento": "B0500300",
			"codigoIbgeMunicipioInvestimento": "3304557",
      		"dataPrimeiraLiberacao": "2020-06-15",
      		"valorPrimeiraLiberacao": 50000,

			"enderecoSedeClienteFinal": {
				"nomeLogradouro": "Rua do cliente",
				"tipoLogradouro": "44",
				"numeroLogradouro": "S/N",
				"complemento": "apt. 203",
				"nomeBairro": "Flamengo",
				"codigoIbgeMunicipio": "3304557",
				"cep": "22230060"
			},

			"amortizacoes": [
				{
					"data": "2021-01-15",
					"valor": "20000.00"
				},
				{
					"data": "2021-04-15",
					"valor": "20000.00"
				},
				{
					"data": "2021-07-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-10-15",
					"valor": "1789.00"
				}
			]
		}
	]
}
`;

export const loteOperacoesExemploPEAC =

  `
{
  "operacoes": [
    {
      "idOperacaoAgente": "creditolivre-1",
      "modalidade": "1",
      "tipoReceitaBruta": "E",
      "receitaBrutaClienteFinal": 360000.01,
      "dataReferenciaReceitaBruta": "2019-12-31",
      "cnpjAgenteFinanceiro": "58017179000170",
      "razaoSocialClienteFinal": "North Central Positronics",
      "cnpjClienteFinal": "46051185000164",
      "riscoOperacao": "AA",
      "dataContratacao": "2020-06-10",
      "valorOperacao": 50000,
      "ecgDeveSerSomadoAoValorOperacao": "N",
      "percentualGarantido": 80,
      "indexadorTaxaJuros": 2,
      "percentualIndexador": 100,
      "taxaEfetivaAnual": 8,
      "outrasGarantias": [
        {
          "tipoGarantia": "1"
        },
        {
          "tipoGarantia": "5"
        }
      ],
      "naturezaClienteFinal": 1,
      "cnaeClienteFinal": "B0500300",
      "cnaeEnquadramento": "B0500300",
      "codigoIbgeMunicipioInvestimento": "3304557",
      "enderecoSedeClienteFinal": {
        "nomeLogradouro": "Rua do cliente",
        "tipoLogradouro": "1",
        "numeroLogradouro": "S/N",
        "complemento": "apt. 203",
        "nomeBairro": "Flamengo",
        "codigoIbgeMunicipio": "3304557",
        "cep": "22230060"
      },
      "identificadorTipoPagamentoEcgTerceiro": "1254",
      "codigoValidadorPagamentoTerceiros": "i56qj6ushr-4ay7lfs7ld34-xwczgio13-saykdhz7xx",
      "dataPrimeiraLiberacao": "2020-06-15",
      "valorPrimeiraLiberacao": 50000,
      "amortizacoes": [
        {
          "data": "2021-02-15",
          "valor": "10000.00"
        },
        {
          "data": "2021-03-15",
          "valor": "10000.00"
        },
        {
          "data": "2021-04-15",
          "valor": "10000.00"
        },
        {
          "data": "2021-05-15",
          "valor": "10000.00"
        },
        {
          "data": "2021-06-15",
          "valor": "10000.00"
        }
      ]
    },
    {
      "idOperacaoAgente": "creditolivre-2",
      "modalidade": "2",
      "tipoReceitaBruta": "E",
      "receitaBrutaClienteFinal": 300000000,
      "dataReferenciaReceitaBruta": "2019-12-31",
      "cnpjAgenteFinanceiro": "58017179000170",
      "razaoSocialClienteFinal": "Tinturaria ABCD",
      "cnpjClienteFinal": "89495936000144",
      "riscoOperacao": "AA",
      "dataContratacao": "2020-06-10",
      "valorOperacao": 80000,
      "ecgDeveSerSomadoAoValorOperacao": "S",
      "percentualGarantido": 80,
      "indexadorTaxaJuros": 3,
      "percentualIndexador": 90,
      "taxaEfetivaAnual": 8,
      "outrasGarantias": [
        {
          "tipoGarantia": "1"
        }
      ],
      "naturezaClienteFinal": 1,
      "cnaeClienteFinal": "B0500300",
      "cnaeEnquadramento": "B0500300",
      "codigoIbgeMunicipioInvestimento": "3304557",
      "dataPrimeiraLiberacao": "2020-06-15",
      "valorPrimeiraLiberacao": 50000,
      "enderecoSedeClienteFinal": {
        "nomeLogradouro": "Rua do cliente",
        "tipoLogradouro": "44",
        "numeroLogradouro": "S/N",
        "complemento": "apt. 203",
        "nomeBairro": "Flamengo",
        "codigoIbgeMunicipio": "3304557",
        "cep": "22230060"
      },
      "identificadorTipoPagamentoEcgTerceiro": "1254",
      "codigoValidadorPagamentoTerceiros": "i56qj6ushr-4ay7lfs7ld34-xwczgio13-saykdhz7xx",
      "amortizacoes": [
        {
          "data": "2021-01-15",
          "valor": "20000.00"
        },
        {
          "data": "2021-04-15",
          "valor": "20000.00"
        },
        {
          "data": "2021-07-15",
          "valor": "10000.00"
        },
        {
          "data": "2021-10-15",
          "valor": "1789.00"
        }
      ]
    }
  ]
}
`;

// JSON de exemplo para importacao de lote de operacoes garantidas

export const loteOperacoesExemploFGTEcgTerceiros =

`
{
	"operacoes": [
		{
			"idOperacaoAgente": "creditolivre-1",
			"modalidade": "1",
			"tipoReceitaBruta": "E",
			"receitaBrutaClienteFinal": 360000.01,
			"dataReferenciaReceitaBruta": "2019-12-31",
			"cnpjAgenteFinanceiro": "79486147000193",
			"razaoSocialClienteFinal": "North Central Positronics",
			"cnpjClienteFinal": "46051185000164",
			"riscoOperacao": "AA",
			"dataContratacao": "2020-06-10",
			"valorOperacao": 50000.00,
			"ecgDeveSerSomadoAoValorOperacao": "N",
			"percentualGarantido" : 80.00,
			"indexadorTaxaJuros": 2,
			"percentualIndexador": 100.00,
			"taxaEfetivaAnual": 8.00,
			"outrasGarantias": [
				{"tipoGarantia": "1"},
				{"tipoGarantia": "5"}
			],
			"naturezaClienteFinal": 1,
			"cnaeClienteFinal": "B0500300",
			"cnaeEnquadramento": "B0500300",
			"codigoIbgeMunicipioInvestimento": "3304557",
			"enderecoSedeClienteFinal": {
				"nomeLogradouro": "Rua do cliente",
				"tipoLogradouro": "1",
				"numeroLogradouro": "S/N",
				"complemento": "apt. 203",
				"nomeBairro": "Flamengo",
				"codigoIbgeMunicipio": "3304557",
				"cep": "22230060"
			},
			"indicadorMicroempreendedorIndividual": "N",
			"indicadorPessoaComDeficiencia": "N",
      "dataPrimeiraLiberacao": "2020-06-15",
      "valorPrimeiraLiberacao": 50000,
      "identificadorTipoPagamentoEcgTerceiro": "1254",
			"codigoValidadorPagamentoTerceiros": "i56qj6ushr-4ay7lfs7ld34-xwczgio13-saykdhz7xx",
			"amortizacoes": [
				{
					"data": "2021-02-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-03-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-04-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-05-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-06-15",
					"valor": "10000.00"
				}
			]
		},
		{
			"idOperacaoAgente": "creditolivre-2",
			"modalidade": "2",
			"tipoReceitaBruta": "E",
			"receitaBrutaClienteFinal": 300000000.00,
			"dataReferenciaReceitaBruta": "2019-12-31",
			"cnpjAgenteFinanceiro": "79486147000193",
			"razaoSocialClienteFinal": "Tinturaria ABCD",
			"cnpjClienteFinal": "89495936000144",
			"riscoOperacao": "AA",
			"dataContratacao": "2020-06-10",
			"valorOperacao": 80000.00,
			"ecgDeveSerSomadoAoValorOperacao": "S",
			"percentualGarantido" : 80.00,
			"indexadorTaxaJuros": 3,
			"percentualIndexador": 90.00,
			"taxaEfetivaAnual": 8.00,
			"outrasGarantias": [
				{"tipoGarantia": "1"}
			],
			"naturezaClienteFinal": 1,
			"cnaeClienteFinal": "B0500300",
			"cnaeEnquadramento": "B0500300",
			"codigoIbgeMunicipioInvestimento": "3304557",
      "dataPrimeiraLiberacao": "2020-06-15",
      "valorPrimeiraLiberacao": 50000,
      "identificadorTipoPagamentoEcgTerceiro": "1254",
			"codigoValidadorPagamentoTerceiros": "i56qj6ushr-4ay7lfs7ld34-xwczgio13-saykdhz7xx",
			"enderecoSedeClienteFinal": {
				"nomeLogradouro": "Rua do cliente",
				"tipoLogradouro": "44",
				"numeroLogradouro": "S/N",
				"complemento": "apt. 203",
				"nomeBairro": "Flamengo",
				"codigoIbgeMunicipio": "3304557",
				"cep": "22230060"
			},
			"indicadorMicroempreendedorIndividual": "N",
			"indicadorPessoaComDeficiencia": "N",
			"amortizacoes": [
				{
					"data": "2021-01-15",
					"valor": "20000.00"
				},
				{
					"data": "2021-04-15",
					"valor": "20000.00"
				},
				{
					"data": "2021-07-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-10-15",
					"valor": "1789.00"
				}
			]
		}
	]
}
`;

export const loteOperacoesExemploFGT =

  `
{
	"operacoes": [
		{
			"idOperacaoAgente": "creditolivre-1",
			"modalidade": "1",
			"tipoReceitaBruta": "E",
			"receitaBrutaClienteFinal": 360000.01,
			"dataReferenciaReceitaBruta": "2019-12-31",
			"cnpjAgenteFinanceiro": "79486147000193",
			"razaoSocialClienteFinal": "North Central Positronics",
			"cnpjClienteFinal": "46051185000164",
			"riscoOperacao": "AA",
			"dataContratacao": "2020-06-10",
			"valorOperacao": 50000.00,
			"ecgDeveSerSomadoAoValorOperacao": "N",
			"percentualGarantido" : 80.00,
			"indexadorTaxaJuros": 2,
			"percentualIndexador": 100.00,
			"taxaEfetivaAnual": 8.00,
			"outrasGarantias": [
				{"tipoGarantia": "1"},
				{"tipoGarantia": "5"}
			],
			"naturezaClienteFinal": 1,
			"cnaeClienteFinal": "B0500300",
			"cnaeEnquadramento": "B0500300",
			"codigoIbgeMunicipioInvestimento": "3304557",
			"enderecoSedeClienteFinal": {
				"nomeLogradouro": "Rua do cliente",
				"tipoLogradouro": "1",
				"numeroLogradouro": "S/N",
				"complemento": "apt. 203",
				"nomeBairro": "Flamengo",
				"codigoIbgeMunicipio": "3304557",
				"cep": "22230060"
			},
			"indicadorMicroempreendedorIndividual": "N",
			"indicadorPessoaComDeficiencia": "N",
      "dataPrimeiraLiberacao": "2020-06-15",
      "valorPrimeiraLiberacao": 50000,
			"amortizacoes": [
				{
					"data": "2021-02-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-03-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-04-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-05-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-06-15",
					"valor": "10000.00"
				}
			]
		},
		{
			"idOperacaoAgente": "creditolivre-2",
			"modalidade": "2",
			"tipoReceitaBruta": "E",
			"receitaBrutaClienteFinal": 300000000.00,
			"dataReferenciaReceitaBruta": "2019-12-31",
			"cnpjAgenteFinanceiro": "79486147000193",
			"razaoSocialClienteFinal": "Tinturaria ABCD",
			"cnpjClienteFinal": "89495936000144",
			"riscoOperacao": "AA",
			"dataContratacao": "2020-06-10",
			"valorOperacao": 80000.00,
			"ecgDeveSerSomadoAoValorOperacao": "S",
			"percentualGarantido" : 80.00,
			"indexadorTaxaJuros": 3,
			"percentualIndexador": 90.00,
			"taxaEfetivaAnual": 8.00,
			"outrasGarantias": [
				{"tipoGarantia": "1"}
			],
			"naturezaClienteFinal": 1,
			"cnaeClienteFinal": "B0500300",
			"cnaeEnquadramento": "B0500300",
			"codigoIbgeMunicipioInvestimento": "3304557",
      "dataPrimeiraLiberacao": "2020-06-15",
      "valorPrimeiraLiberacao": 50000,
			"enderecoSedeClienteFinal": {
				"nomeLogradouro": "Rua do cliente",
				"tipoLogradouro": "44",
				"numeroLogradouro": "S/N",
				"complemento": "apt. 203",
				"nomeBairro": "Flamengo",
				"codigoIbgeMunicipio": "3304557",
				"cep": "22230060"
			},
			"indicadorMicroempreendedorIndividual": "N",
			"indicadorPessoaComDeficiencia": "N",
			"amortizacoes": [
				{
					"data": "2021-01-15",
					"valor": "20000.00"
				},
				{
					"data": "2021-04-15",
					"valor": "20000.00"
				},
				{
					"data": "2021-07-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-10-15",
					"valor": "1789.00"
				}
			]
		}
	]
}
`;

export const loteOperacoesExemploFGEnergia =

`
{
	"operacoes": [
		{
			"idOperacaoAgente": "creditolivre-1",
			"modalidade": "1",
			"tipoReceitaBruta": "E",
			"receitaBrutaClienteFinal": 360000.01,
			"dataReferenciaReceitaBruta": "2019-12-31",
			"cnpjAgenteFinanceiro": "79486147000193",
			"razaoSocialClienteFinal": "North Central Positronics",
			"cnpjClienteFinal": "46051185000164",
			"codigoValidacaoProjeto" : "##COD_VALIDACAO_PROJETO##",
			"riscoOperacao": "AA",
			"dataContratacao": "2020-06-10",
			"valorOperacao": 50000.00,
			"ecgDeveSerSomadoAoValorOperacao": "N",
			"indexadorTaxaJuros": 2,
			"percentualIndexador": 100.00,
			"taxaEfetivaAnual": 8.00,
			"outrasGarantias": [
				{"tipoGarantia": "1"},
				{"tipoGarantia": "5"}
			],
			"naturezaClienteFinal": 1,
			"cnaeClienteFinal": "B0500300",
			"cnaeEnquadramento": "B0500300",
			"codigoIbgeMunicipioInvestimento": "3304557",
			"enderecoSedeClienteFinal": {
				"nomeLogradouro": "Rua do cliente",
				"tipoLogradouro": "1",
				"numeroLogradouro": "S/N",
				"complemento": "apt. 203",
				"nomeBairro": "Flamengo",
				"codigoIbgeMunicipio": "3304557",
				"cep": "22230060"
			},
      		"dataPrimeiraLiberacao": "2020-06-15",
      		"valorPrimeiraLiberacao": 50000,
			"amortizacoes": [
				{
					"data": "2021-02-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-03-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-04-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-05-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-06-15",
					"valor": "10000.00"
				}
			]
		},
		{
			"idOperacaoAgente": "creditolivre-2",
			"modalidade": "2",
			"tipoReceitaBruta": "E",
			"receitaBrutaClienteFinal": 300000000.00,
			"dataReferenciaReceitaBruta": "2019-12-31",
			"cnpjAgenteFinanceiro": "79486147000193",
			"razaoSocialClienteFinal": "Tinturaria ABCD",
			"cnpjClienteFinal": "89495936000144",
			"codigoValidacaoProjeto" : "##COD_VALIDACAO_PROJETO##",
			"riscoOperacao": "AA",
			"dataContratacao": "2020-06-10",
			"valorOperacao": 80000.00,
			"ecgDeveSerSomadoAoValorOperacao": "S",
			"indexadorTaxaJuros": 3,
			"percentualIndexador": 90.00,
			"taxaEfetivaAnual": 8.00,
			"outrasGarantias": [
				{"tipoGarantia": "1"}
			],
			"naturezaClienteFinal": 1,
			"cnaeClienteFinal": "B0500300",
			"cnaeEnquadramento": "B0500300",
			"codigoIbgeMunicipioInvestimento": "3304557",
      		"dataPrimeiraLiberacao": "2020-06-15",
      		"valorPrimeiraLiberacao": 50000,

			"enderecoSedeClienteFinal": {
				"nomeLogradouro": "Rua do cliente",
				"tipoLogradouro": "44",
				"numeroLogradouro": "S/N",
				"complemento": "apt. 203",
				"nomeBairro": "Flamengo",
				"codigoIbgeMunicipio": "3304557",
				"cep": "22230060"
			},

			"amortizacoes": [
				{
					"data": "2021-01-15",
					"valor": "20000.00"
				},
				{
					"data": "2021-04-15",
					"valor": "20000.00"
				},
				{
					"data": "2021-07-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-10-15",
					"valor": "1789.00"
				}
			]
		}
	]
}
`;

// JSON de exemplo para importacao de lote de operacoes garantidas

export const loteOperacoesExemploFGSEBRAE =

  `
{
	"operacoes": [
		{
			"idOperacaoAgente": "creditolivre-1",
			"modalidade": "1",
			"tipoReceitaBruta": "E",
			"receitaBrutaClienteFinal": 360000.01,
			"dataReferenciaReceitaBruta": "2019-12-31",
			"cnpjAgenteFinanceiro": "79486147000193",
			"razaoSocialClienteFinal": "North Central Positronics",
			"cnpjClienteFinal": "46051185000164",
			"riscoOperacao": "AA",
			"dataContratacao": "2020-06-10",
			"valorOperacao": 50000.00,
			"ecgDeveSerSomadoAoValorOperacao": "N",
			"percentualGarantido" : 80.00,
			"indexadorTaxaJuros": 2,
			"percentualIndexador": 100.00,
			"taxaEfetivaAnual": 8.00,
			"outrasGarantias": [
				{"tipoGarantia": "1"},
				{"tipoGarantia": "5"}
			],
			"naturezaClienteFinal": 1,
			"cnaeClienteFinal": "B0500300",
			"cnaeEnquadramento": "B0500300",
			"codigoIbgeMunicipioInvestimento": "3304557",
			"enderecoSedeClienteFinal": {
				"nomeLogradouro": "Rua do cliente",
				"tipoLogradouro": "1",
				"numeroLogradouro": "S/N",
				"complemento": "apt. 203",
				"nomeBairro": "Flamengo",
				"codigoIbgeMunicipio": "3304557",
				"cep": "22230060"
			},
			"indicadorMicroempreendedorIndividual": "N",
			"indicadorPessoaComDeficiencia": "N",
			"telefoneBeneficiario" : "88977665544",
			"numeroAgenciaBeneficiario" : "4555",
			"nomeSocioBeneficiario" : "João Souza Melo",
			"emailBeneficiario" : "joao.souza@gmail.com",
			"cpfSocioBeneficiario" : "99988877766",
			"dataNascSocioBeneficiario" : "1994-02-26",
			"generoSocioBeneficiario" : "1",
      		"dataPrimeiraLiberacao": "2020-06-15",
      		"valorPrimeiraLiberacao": 50000,
			"amortizacoes": [
				{
					"data": "2021-02-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-03-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-04-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-05-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-06-15",
					"valor": "10000.00"
				}
			]
		},
		{
			"idOperacaoAgente": "creditolivre-2",
			"modalidade": "2",
			"tipoReceitaBruta": "E",
			"receitaBrutaClienteFinal": 300000000.00,
			"dataReferenciaReceitaBruta": "2019-12-31",
			"cnpjAgenteFinanceiro": "79486147000193",
			"razaoSocialClienteFinal": "Tinturaria ABCD",
			"cnpjClienteFinal": "89495936000144",
			"riscoOperacao": "AA",
			"dataContratacao": "2020-06-10",
			"valorOperacao": 80000.00,
			"ecgDeveSerSomadoAoValorOperacao": "S",
			"percentualGarantido" : 80.00,
			"indexadorTaxaJuros": 3,
			"percentualIndexador": 90.00,
			"taxaEfetivaAnual": 8.00,
			"outrasGarantias": [
				{"tipoGarantia": "1"}
			],
			"naturezaClienteFinal": 1,
			"cnaeClienteFinal": "B0500300",
			"cnaeEnquadramento": "B0500300",
			"codigoIbgeMunicipioInvestimento": "3304557",
      		"dataPrimeiraLiberacao": "2020-06-15",
      		"valorPrimeiraLiberacao": 50000,

			"enderecoSedeClienteFinal": {
				"nomeLogradouro": "Rua do cliente",
				"tipoLogradouro": "44",
				"numeroLogradouro": "S/N",
				"complemento": "apt. 203",
				"nomeBairro": "Flamengo",
				"codigoIbgeMunicipio": "3304557",
				"cep": "22230060"
			},
			"indicadorMicroempreendedorIndividual": "N",
			"indicadorPessoaComDeficiencia": "N",
			"amortizacoes": [
				{
					"data": "2021-01-15",
					"valor": "20000.00"
				},
				{
					"data": "2021-04-15",
					"valor": "20000.00"
				},
				{
					"data": "2021-07-15",
					"valor": "10000.00"
				},
				{
					"data": "2021-10-15",
					"valor": "1789.00"
				}
			]
		}
	]
}
`;


export const loteLiberacoesExemplo =
`
{
  "liberacoesParaOperacoes": [
    {
      "idOperacaoAgente": "creditolivre-1",
      "liberacoes": [
        {
        "data": "2020-06-20",
        "valor": 25000.00
        },
        {
        "data": "2020-07-25",
        "valor": 25000.00
        }
      ],
	  "amortizacoes": [
		{
			"data": "2021-02-15",
			"valor": "6250.00"
		},
		{
			"data": "2021-03-15",
			"valor": "6250.00"
		},
		{
			"data": "2021-04-15",
			"valor": "6250.00"
		},
		{
			"data": "2021-05-15",
			"valor": "6250.00"
		},
		{
			"data": "2021-06-15",
			"valor": "6250.00"
		},
		{
			"data": "2021-07-15",
			"valor": "6250.00"
		},
		{
			"data": "2021-08-15",
			"valor": "6250.00"
		},
		{
			"data": "2021-09-15",
			"valor": "6250.00"
		}	]
    }
  ]
}
`;


export const loteAmortizacoesExemplo =
`
{
  "cnpjAgenteFinanceiro": "33657248000189",
  "amortizacoesAntecipadas": [
    {
      "idOperacaoAgente": "creditolivre-1",
      "dataPagamentoAmortizacao": "2021-04-20",
	  "valorTotalAmortizacaoAntecipada": "20000.00",
	  "fluxoParcelasAposAmortizacao": [
        {
        "data": "2020-06-20",
        "valor": 25000.00
        },
        {
        "data": "2020-07-25",
        "valor": 25000.00
        }
      ]
    },
    {
      "idOperacaoAgente": "creditolivre-2",
      "dataPagamentoAmortizacao": "2021-04-18",
	  "valorTotalAmortizacaoAntecipada": "50000.00",
	  "fluxoParcelasAposAmortizacao": [
		{
			"data": "2021-02-15",
			"valor": "6250.00"
		},
		{
			"data": "2021-03-15",
			"valor": "6250.00"
		},
		{
			"data": "2021-04-15",
			"valor": "6250.00"
		},
		{
			"data": "2021-05-15",
			"valor": "6250.00"
		},
		{
			"data": "2021-06-15",
			"valor": "6250.00"
		},
		{
			"data": "2021-07-15",
			"valor": "6250.00"
		},
		{
			"data": "2021-08-15",
			"valor": "6250.00"
		},
		{
			"data": "2021-09-15",
			"valor": "6250.00"
        }
      ]
    }
  ]
}
`;
